// extracted by mini-css-extract-plugin
module.exports = {"rule-table":"RuleTable_rule-table__1dQz7","rule-table--title":"RuleTable_rule-table--title__dJcLp","lowflow-header":"RuleTable_lowflow-header__2PV75"};